export const ETAX_PATH = "/e-tax";
export const ETAX_SEND_PATH = `${ETAX_PATH}/send`;

/** The send page's second tab: ใบลดหนี้ / ใบเพิ่มหนี้. */
export const ETAX_NOTE_SEND_PATH = `${ETAX_SEND_PATH}/notes`;
